import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Tag from './icon-tag.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Tag {...validProps} />;
}
SvgComponent.iconName = 'tag';

/**
 * @deprecated This is a legacy icon
 */
export const TagIcon = svgIconWrapper(SvgComponent);
